import {IconButton} from 'platform/components';
import {Box, Center, Show, Text} from 'platform/foundation';

import {useGetMyTasksCountQuery} from '@dms/api/core';
import {UserSidebarIconSize} from '@dms/api/shared';
import {useFocusControl} from '@dms/shared';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

interface TaskCenterHeaderButtonProps extends RequiredTestIdProps {
  isOpen: boolean;
  iconSize: UserSidebarIconSize;
}

export function TaskCenterHeaderButton(props: TaskCenterHeaderButtonProps) {
  const {data: tasksCount} = useGetMyTasksCountQuery();
  const {isDisabled} = useFocusControl();

  return (
    <Box position="relative" width="100%" height="100%">
      <Center width="100%" height="100%">
        <IconButton
          aria-label="topBar"
          iconSize={props.iconSize}
          icon="action/assignment_turned_in"
          tabIndex={isDisabled ? -1 : 0}
          data-testid={suffixTestId('taskCenter-button', props)}
        />
        <Show when={(tasksCount?.count ?? 0) > 0}>
          <Box
            position="absolute"
            top={2}
            right={2}
            backgroundColor="severity.danger"
            width={4}
            height={4}
            borderRadius="circular"
          >
            <Center justify="center" width="100%" height="100%">
              <Text size="xxSmall" alternative color="white">
                {tasksCount?.count}
              </Text>
            </Center>
          </Box>
        </Show>
      </Center>
    </Box>
  );
}
